import { useContext } from "react";
import { LoginModalContext } from "@features";

export const useLoginModalProvider = () => {
  const context = useContext(LoginModalContext);

  if (!context) {
    throw new Error("useLoginContext must be used within a LoginProvider");
  }

  return context;
};
